import React, {
  useContext,
  useEffect,
  useState,
} from "react";
import { VotingContext } from "./VotingNavigation";
import { AppStore } from "../../components/AppStore";
import PlayStore from "../../components/PlayStore";
import { Dimensions, StyleSheet, View } from "react-native";
import { colors } from "../../common/styles/colors";
import axios from "axios";
import ReactLoading from "react-loading";
import { CommonLoading } from "../../components/CommonLoading";
import { MascotBlackHappy } from "../../common/icons/mascot_black_happy";

const branchAxios = axios.create({
  baseURL: "https://api2.branch.io",
});

export const HomePage = () => {
  const { name, meeting } = useContext(VotingContext);

  const [deepLink, setDeepLink] = useState("");
  const [deepLinkLoading, setDeepLinkLoading] =
    useState(false);

  useEffect(() => {
    if (meeting && meeting?.author?.id) {
      setDeepLinkLoading(true);
      branchAxios
        .post("/v1/url", {
          branch_key: process.env.REACT_APP_BRANCH_KEY,
          feature: "referrals",
          data: {
            referringUserID: String(meeting?.author?.id),
            $canonical_url: `gadder://otherProfile/${meeting?.author?.id}`,
          },
        })
        .then(({ data: { url } }) => {
          setDeepLink(url);
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => setDeepLinkLoading(false));
    }
  }, [meeting]);

  return (
    <>
      {deepLinkLoading ? (
        <CommonLoading />
      ) : (
        <div style={styles.home}>
          <div
            style={{
              marginBottom: 158,
              ...styles.container,
            }}
          >
            <MascotBlackHappy />
            <span style={styles.title}>
              Well done{name ? ", " + name : ""}!
            </span>
            <span style={styles.text}>
              Download gadder to discover people and places.
            </span>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              maxWidth: 700,
              width: "100%",
            }}
          >
            <PlayStore deepLink={deepLink} />
            <AppStore deepLink={deepLink} />
          </div>
        </div>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  title: {
    fontSize: 25,
    marginBottom: 8,
    marginTop: 83,
    fontWeight: "bold",
  },

  home: {
    display: "flex",
    flex: 1,
    fontSize: 18,
    flexDirection: "column",
    paddingLeft: 36,
    paddingRight: 36,
    height: Dimensions.get("window").height,
    textAlign: "center",
    paddingTop: 86,
    alignItems: "center",
  },

  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  text: {
    fontSize: 18,
    maxWidth: 240,
  },
});
